export default __webpack_public_path__ + "static/media/heart-red.68896750.svg";